import { useCallback, useEffect, useState } from "react";
import { MobileMenuBar, Sidebar } from "@/components/pipeline/PipelineShell";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { labStatus, listJobs, listPosts } from "@/lib/fbLabApi";
import { ExtensionCard } from "@/components/fblab/ExtensionCard";
import { PrimaryGroupCard } from "@/components/fblab/PrimaryGroupCard";
import { PublishCard } from "@/components/fblab/PublishCard";
import { PostsCard } from "@/components/fblab/PostsCard";
import { AnalyticsCard } from "@/components/fblab/AnalyticsCard";

// Preview-only, Super Admin proof of concept for the Facebook Group Chrome extension. The server returns 404 outside preview.
export default function FbLab() {
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  const [tick, setTick] = useState(0);
  const load = useCallback(async () => {
    try {
      const [status, jobs, posts] = await Promise.all([labStatus(), listJobs(), listPosts()]);
      setD({ status, jobs, posts }); setTick((t) => t + 1);
    } catch (e) { setErr(e?.response?.status === 404 ? "The Facebook Lab is only available in the preview environment." : "Could not load the Facebook Lab."); }
  }, []);
  useEffect(() => { load(); const t = setInterval(load, 20000); return () => clearInterval(t); }, [load]);
  return (
    <div className="min-h-screen bg-stone-100 lg:pl-60">
      <Sidebar />
      <MobileMenuBar />
      <main data-testid="fb-lab" className="p-4 sm:p-8 max-w-6xl space-y-4">
        <h1 className="font-display text-3xl font-extrabold">Facebook Lab</h1>
        <p data-testid="fb-lab-warning" className="text-xs text-amber-900 bg-amber-50 border border-amber-200 rounded-lg p-2">
          Preview-only proof of concept for {d?.status.company_name || "this company"}. Posts go only to your private test group. Facebook doesn't officially support
          automated posting or reading of groups; heavy or fast automation can lead to rate limits, feature blocks or account restrictions. The extension works
          slowly, one job at a time, and stops at any login or security check.
        </p>
        {err && <p data-testid="fb-lab-error" className="text-sm text-red-700">{err}</p>}
        {d && (
          <Tabs defaultValue="setup">
            <TabsList className="flex flex-wrap h-auto justify-start">
              <TabsTrigger value="setup" data-testid="fb-lab-tab-setup">Setup</TabsTrigger>
              <TabsTrigger value="publish" data-testid="fb-lab-tab-publish">Publish</TabsTrigger>
              <TabsTrigger value="comments" data-testid="fb-lab-tab-comments">Comments & Bids</TabsTrigger>
              <TabsTrigger value="analytics" data-testid="fb-lab-tab-analytics">Analytics</TabsTrigger>
            </TabsList>
            <TabsContent value="setup" className="space-y-4"><ExtensionCard status={d.status} onChange={load} /><PrimaryGroupCard url={d.status.primary_group_url} /></TabsContent>
            <TabsContent value="publish"><PublishCard groupUrl={d.status.primary_group_url} jobs={d.jobs} onChange={load} /></TabsContent>
            <TabsContent value="comments"><PostsCard posts={d.posts} jobs={d.jobs} hasGroup={!!d.status.primary_group_url} onChange={load} /></TabsContent>
            <TabsContent value="analytics"><AnalyticsCard refreshKey={tick} /></TabsContent>
          </Tabs>
        )}
      </main>
    </div>
  );
}
